"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4902],{

/***/ 24902:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ HeaderNavItem; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(41120);
/* harmony import */ var _material_ui_core_ListItem__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(50998);
/* harmony import */ var _components_CustomDropdown_CustomDropdown_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61707);
/* harmony import */ var _components_CustomButtons_Button_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(16719);
/* harmony import */ var _styles_jss_bbhost_pages_componentsSections_navbarsStyle_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(28886);
/* harmony import */ var lang_lang_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(34426);
/*eslint-disable*/ 



// @material-ui/core components


// core components



var useStyles = (0,_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_styles_jss_bbhost_pages_componentsSections_navbarsStyle_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
    name: "headerNavItem"
});

function HeaderNavItem(param) {
    var nav = param.nav, active_name = param.active_name;
    var classes = useStyles();
    var locale = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)().locale;
    var item = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    if (typeof nav.text === "object") {
        nav.text = (0,lang_lang_js__WEBPACK_IMPORTED_MODULE_8__/* .getLangFromObj */ .x)(nav.text, locale);
    }
    if (nav.type == "link") {
        item = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
            href: nav.route,
            as: nav.route,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_CustomButtons_Button_js__WEBPACK_IMPORTED_MODULE_5__["default"], {
                href: nav.route,
                color: "transparent",
                className: classes.navLink + " " + (nav.name == active_name ? classes.navLinkActive : ""),
                children: nav.text
            })
        });
    } else if (nav.type == "dropdown") {
        var activeMenu = {
            active: false,
            name: ""
        };
        var itensList = nav.itens.map(function(item, key) {
            if (typeof item.text === "object") {
                item.text = (0,lang_lang_js__WEBPACK_IMPORTED_MODULE_8__/* .getLangFromObj */ .x)(item.text, locale);
            }
            if (item.name == active_name) {
                activeMenu.active = true;
                activeMenu.name = item.name;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_CustomButtons_Button_js__WEBPACK_IMPORTED_MODULE_5__["default"], {
                    href: item.route,
                    color: "info",
                    className: classes.dropdownLink,
                    children: item.text
                });
            }
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                href: item.route,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                    className: classes.dropdownLink,
                    children: item.text
                })
            }, item.name);
        });
        item = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_CustomDropdown_CustomDropdown_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            noLiPadding: true,
            navDropdown: true,
            hoverColor: "info",
            buttonText: nav.text,
            buttonProps: {
                className: classes.navLink + " " + (activeMenu.active ? classes.navLinkActive : ""),
                color: "transparent"
            },
            dropdownList: itensList
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_ListItem__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
        className: classes.listItem,
        children: item
    });
}


/***/ })

}]);